var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerCard"},[_c('div',{staticClass:"CardData",staticStyle:{"width":"40%"}},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"CardData"},[_vm._v(": "+_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }